module.exports = __webpack_public_path__ + "images/company/checkmark_feea7091d3f03dacfda5f43e71020847.svg";